import React, { useState, useEffect }from 'react';
import { useParams } from "react-router-dom";
import { TailSpin } from  'react-loader-spinner'
import axios from 'axios';
import SftGlobalData from '../library/SftGlobalData';
import Colors from '../library/Colors';

import ShippingCustomer from '../components/shipping/ShippingCustomer';
import ShippingSender from '../components/shipping/ShippingSender';
import ShippingProvider from '../components/shipping/ShippingProvider';
import ShippingOptions from '../components/shipping/ShippingOptions';
import ShippingPrint from '../components/shipping/ShippingPrint';


const ShippingScreen = (props) =>  {
    const params = useParams();     
    const [loading, setLoading] = useState(false); 
    const [storeSet, setStoreSet] = useState(false);
    const [currentForm, setCurrentForm] = useState("ShippingCustomer");
    const [currentStepDirection, setCurrentStepDirection] = useState(true);
    const [error, setError] = useState('');       
    const [providers, setProviders] = useState([]);
    const [visitForm, setVisitForm] = useState([]);
    const [receiptNr, setReceiptNr] = useState(0);
    const [selectedStore, setSelectedStore] = useState(0);
    const [showCustomerForm, setShowCustomerForm]   = useState(1);
    const [showShipperForm, setShowShipperForm]     = useState(1);
    const [showProviderForm, setShowProviderForm]   = useState(1);
    const [showOptionsForm, setShowOptionsForm]     = useState(1);  
    const [showPrintForm, setShowPrintForm]         = useState(1);  
    const [showLabelButton, setShowLabelButton]     = useState("ALL");
    const [selectedPrintOption, setSelectedPrintOption] = useState();
    const [selectedOption, setSelectedOption] = useState(0);
    const [defaultShippingOption, setDefaultShippingOption] = useState();
    const [defaultShippingSettings, setDefaultShippingSettings] = useState({be: "", nbe: ""});
    const [onlyShowProviders, setOnlyShowProviders] = useState([]);
    const [printReturnLabel, setPrintReturnLabel] = useState(false);
    const [senderOverwriteStore, setSenderOverwriteStore] = useState(0);
    const [stores, setStores] = useState([]);
    const [countries, setCountries] = useState([]);
    const [sftAccountId, setSftAccountId] = useState(null);
    const [customerData, setCustomerData]   = useState({firstname: "", lastname: "", company: "", street_name: "", house_number: "", house_number_addition: "", zip: "", city: "",country: "",email: "", phone: "", language: "", remark: ""});
    const [shipperData, setShipperData]     = useState({name: "", company: "", street_name: "", house_number: "", zip: "", city: "", country: "", email: "", phone: ""});
    const [shipmentTypeData, setShipmentTypeData]   = useState({shipper: "", provider: ""});
    const [shipmentOptionsData, setShipmentOptionsData] = useState({shipment_type: "", tracking_email: "invisible", tracking_sms: "invisible", saturday_delivery: "invisible", second_delivery: "invisible", evening_delivery: "invisible", return_label: "invisible", sameday_delivery: "invisible", signed: "invisible", basic_insurance: "invisible", extra_insurance: "0", weight: "0", parcelValue: "0", delivery_date: "01-01-2022", parcels: "1", paper_size: "A6"});
    const [receiptParcelValue, setReceiptParcelValue] = useState(null);
    const [receiptParcelWeight, setReceiptParcelWeight] = useState(null);
    const [autofillParcel, setAutofillParcel] = useState("");
    const [pickupEnabled, setPickupEnabled] = useState(false);
    const [pickupProvider, setPickupProvider] = useState('');
    const [pickupId, setPickupId] = useState("");
    const [pickupType, setPickupType] = useState("");
    const [pickupPoint, setPickupPoint] = useState(null);
    const [usePickupMode, setUsePickupMode] = useState(false);

    // Check if parcel data should be auto-filled based on kasvar setting
    // autofillParcel can be: "" (disabled), "ALL" (always), or comma-separated shipment types
    const shouldAutofillParcel = (shipmentType) => {
        if (!autofillParcel || autofillParcel === "") return false;
        if (autofillParcel.toUpperCase() === "ALL") return true;
        const types = autofillParcel.toUpperCase().split(",").map(t => t.trim());
        return types.some(t => (shipmentType || "").toUpperCase().includes(t));
    };

    /*
    let customer            = {firstname: "", lastname: "", company: "", street_name: "", house_number: "",zip: "", city: "",country: "",email: "", phone: "", language: ""};
    let shipper             = {name: "", company: "", street_name: "", house_number: "", zip: "", city: "", country: "", email: "", phone: ""};
    let shipment_type       = {shipper: "", provider: ""};
    let shipment_options    = {shipment_type: "", tracking_email: "", tracking_sms: "", saturday_delivery: "", second_delivery: "", evening_delivery: "", return_label: "", sameday_delivery: "", signed: "", basic_insurance: "", extra_insurance: "", weight: "", delivery_date: "", parcels: ""};*/

    useEffect(() => {
        if(props.api !== ''){
            let getLang = "NED";
            if(props.lang.toLowerCase() === "en"){
                getLang = "ENG";
            } else if(props.lang.toLowerCase() === "fr"){
                getLang = "FRA";
            }

            // Fetch ONLY the account id — never pull decrypted DB credentials / API token to the browser.
            SftGlobalData.post('connection&action=getAccountId', {key: props.api, user: props.username, sftUserId: props.userId}).then(response => {
                const accountId = response.data?.account_id ?? null;
                setSftAccountId(accountId);

                if(SftGlobalData.debug) {
                    console.log('[Shipping] Account id loaded:', { account_id: accountId });
                }
            });
          
            SftGlobalData.post('sftData',  { key: props.api,  type: "countries", language: getLang }).then(response => {   
                setCountries(response.data.data);
            });

            SftGlobalData.post('sftData',  { key: props.api,  type: "stores"}).then(response => {
                let storesData = response.data.data;
                setStores(storesData);
                if(storesData.length === 1){
                    let shipper = {name: storesData[0]["shipping_name"], company: storesData[0]["shipping_company"], street_name: storesData[0]["shipping_street_name"], house_number: storesData[0]["shipping_street_number"], zip: storesData[0]["shipping_zip"], city: storesData[0]["shipping_city"], country: storesData[0]["shipping_country"], email: storesData[0]["shipping_email"], phone: storesData[0]["shipping_phone"]};
                    //console.log("shipperData", shipper);
                    setShipperData(shipper);
                    // Hiding the shipper form when there's a single store + a known receipt is handled by a
                    // dedicated effect below (keyed on receiptNr), so this fetch effect doesn't need to re-run
                    // on every receiptNr change — typing in the order-nr field was re-triggering it otherwise.
                } else {
                    if(typeof params.storeId !== "undefined" && params.storeId.length > 1 && storesData.length > 0){
                        let selectedStoreIndex = storesData.findIndex(x => x.code == params.storeId); //find the index where store id is in the field code
                        setSelectedStore(selectedStoreIndex);
                        storesData.forEach(row => {
                            if(row["code"] === params.storeId){
                                let shipper2 = {name: row["shipping_name"], company: row["shipping_company"], street_name: row["shipping_street_name"], house_number: row["shipping_street_number"], zip: row["shipping_zip"], city: row["shipping_city"], country: row["shipping_country"], email: row["shipping_email"], phone: row["shipping_phone"]};
                                setShipperData(shipper2);
                                //console.log("shipper2", shipper2);
                                if(params.receiptNr !== undefined && params.receiptNr.length > 1){
                                    setShowShipperForm(false);
                                }
                            }
                        });
                    }
                }
            });               
        }
     },[props.api, props.lang]);

    // When a single store is configured and a receipt is loaded, hide the shipper form. Kept separate from
    // the fetch effect above so it reacts to receiptNr changes (e.g. URL load) without re-fetching account/
    // countries/stores on every keystroke in the order-number input.
    useEffect(()=>{
        if(stores.length === 1 && receiptNr !== 0){
            setShowShipperForm(false);
        }
    },[receiptNr, stores]);

    useEffect(()=>{
        let sftReceipt = (params.receiptNr?.includes("_sft"));
        params.receiptNr = params.receiptNr?.replace("_sft", "");

        setReceiptNr(params.receiptNr);  
        if(params.receiptNr !== undefined && params.receiptNr.length > 1){    
            if(!sftReceipt){
                props.setHideSidebar(true);
                props.setHideTopbar(true);
            }
            let pos_id = "";


            SftGlobalData.post('shipping&action=fetchReceipt', { key: props.api, receipt_nr: params.receiptNr }).then(response => {
                if(params.receiptNr !== undefined){
                    setReceiptNr(params.receiptNr.replace(/[']/g, ''));                
                }
                setLoading(false);                     
                
                let customer            = {firstname: "", lastname: "", company: "", street_name: "", house_number: "", house_number_addition: "", zip: "", city: "",country: "",email: "", phone: "", language: "", remark: ""};
                customer.firstname      = response.data.firstname;
                customer.lastname       = response.data.lastname;
                customer.company        = response.data.company;
                customer.street_name    = response.data.address;
                customer.house_number   = response.data.house_number;
                customer.house_number_addition = response.data.house_number_addition;
                customer.zip            = response.data.zip;
                customer.city           = response.data.city;
                customer.country        = response.data.isocode;
                customer.email          = response.data.email;
                customer.phone          = response.data.gsm;
                customer.store_id       = response.data.store_id;
                customer.remark         = response.data?.remarks ?? "";
                if(response.data?.parcel_value !== null && response.data?.parcel_value !== undefined) {
                    setReceiptParcelValue(String(Math.round(response.data.parcel_value)));
                }
                if(response.data?.parcel_weight !== null && response.data?.parcel_weight !== undefined) {
                    setReceiptParcelWeight(String(Math.round(response.data.parcel_weight)));
                }
                if(response.data?.autofill_parcel) {
                    setAutofillParcel(response.data.autofill_parcel);
                }
                // Pickup point prefill: only honour when pickup_type indicates a real pickup (not 42500).
                if(response.data?.pickup_id && response.data?.pickup_type && response.data.pickup_type !== "42500"){
                    setPickupId(String(response.data.pickup_id));
                    setPickupType(String(response.data.pickup_type));
                    setUsePickupMode(true);
                } else {
                    setPickupId("");
                    setPickupType("");
                    setPickupPoint(null);
                    setUsePickupMode(false);
                }
                setCustomerData(customer);
                if(typeof params.storeId !== "undefined" && params.storeId.length > 1){
                    setStoreSet(true);
                } else {
                    setStoreSet(false);
                }
            });
        }else {
            setLoading(false);
        }

        SftGlobalData.post('shipping&action=fetchSettings', { key: props.api, receipt_nr: params.receiptNr }).then(response => {
            if(response.data){
                if(params.receiptNr !== 0 && params.receiptNr){
                    setShowCustomerForm(response.data.show_customer_data);
                    setShowShipperForm(response.data.show_customer_data);
                    setShowProviderForm(response.data.show_shipping_methode);
                    setShowOptionsForm(response.data.show_shipping_methode);
                    setShowPrintForm(response.data.bpost_auto_print);
                }                    
                setShowLabelButton(response.data?.show_label_button);
                // The shipping_pickup_provider kasvar is the single switch for pickup points: without it
                // there is no provider to look points up with, so the toggle must not appear at all.
                // The old bpost fallback (any bpost_pickup_token implies pickup) is gone deliberately —
                // it showed the toggle to shops that were never configured for pickup. Requiring the
                // provider here as well as in fetchSettings keeps that true against an older backend.
                const configuredPickupProvider = response.data?.pickup_provider || '';
                setPickupProvider(configuredPickupProvider);
                setPickupEnabled(!!configuredPickupProvider && !!response.data?.pickup_enabled);
                
                let shipment_type       = {shipper: "", provider: ""};
                shipment_type.shipper   = response.data.shipper;
                shipment_type.provider  = response.data.provider;

                // bpost_print_return_label kasvar: needed for pickup shipments, which skip
                // fetchShippingOptions (where this setting is normally folded into return_label).
                setPrintReturnLabel(!!response.data?.print_return_label);
                setOnlyShowProviders(response?.data.only_show_providers ?? []);
                setSenderOverwriteStore(response?.data.shipping_overwrite_store ?? 0);
                // `||`, not `??`: bpost_shipment_type_nbe is rolled out to every database with an empty
                // value, and an empty kasvar means "no separate foreign type — use the BE one". `??`
                // only catches a missing kasvar (NULL), so it would leave the foreign default blank on
                // every database that has the row but hasn't filled it in.
                const shipperNbe = response.data.shipperNbe || response.data.shipper;
                setDefaultShippingSettings({be: response.data.shipper, nbe: shipperNbe});
                setShipmentTypeData(shipment_type);
                setDefaultShippingOption((customerData.country === "BE" || customerData.country === "") ? response.data.shipper : shipperNbe);
                setShipmentOptionsData({
                    shipment_type: (customerData.country === "BE" || customerData.country === "") ? response.data.shipper : shipperNbe,
                    tracking_email: "invisible", tracking_sms: "invisible", saturday_delivery: "invisible", second_delivery: "invisible", evening_delivery: "invisible",
                    return_label: "invisible", sameday_delivery: "invisible", signed: "invisible", basic_insurance: "invisible", extra_insurance: "0",
                    weight: "0",
                    parcelValue: "0",
                    delivery_date: "01-01-2022", parcels: "1", paper_size: response.data.bpost_paper_size
                });    
            }

            reloadProviders();
        });
   
    }, [props.api], [params.receiptNr])

    // Keep the default shipment type in step with the customer's country, however that country arrives.
    // updateDefaultShipper only fires from the country dropdown's onChange, so a receipt that loads with
    // a foreign address never triggered it — and the fetchSettings handler above closes over the initial
    // customerData, where country is still "", so it always picked the Belgian default. That left
    // bpost_shipment_type_nbe looking broken for exactly the flow it exists for.
    useEffect(() => {
        const country = customerData.country || "";
        const next = (country === "BE" || country === "")
            ? defaultShippingSettings.be
            : defaultShippingSettings.nbe;
        if (!next) return;
        setDefaultShippingOption(next);
        // Only replace a shipment type that is still one of the two defaults — never a manual choice
        // the user already made on the options step.
        setShipmentOptionsData(prev => (
            prev.shipment_type === ""
            || prev.shipment_type === defaultShippingSettings.be
            || prev.shipment_type === defaultShippingSettings.nbe
                ? {...prev, shipment_type: next}
                : prev
        ));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customerData.country, defaultShippingSettings])

    const reloadProviders = () => {
        setLoading(true);      
        SftGlobalData.post('shipping&action=fetchShippingProviders', { key: props.api }).then(response => {
            if(response.data?.[0]?.platform == "myparcel"){
                setShipmentOptionsData({
                    shipment_type: (customerData.country === "BE" || customerData.country === "") ? response.data.shipper : response.data.shipperNbe ?? response.data.shipper,
                    tracking_email: "invisible", tracking_sms: "invisible", saturday_delivery: "invisible", second_delivery: "invisible", evening_delivery: "invisible", 
                    return_label: "invisible", sameday_delivery: "invisible", signed: "invisible", basic_insurance: "invisible", extra_insurance: "invisible", weight: "invisible", 
                    parcelValue: "invisible", delivery_date: "01-01-2022", parcels: "1", paper_size: response.data.bpost_paper_size 
                });
            }
            setLoading(false);                                    
            setProviders(response.data);  
        });
    }

    useEffect(() => {
        // If senderOverwriteStore is set (not 0), use that store instead of customerData.store_id or params.storeId
        if (senderOverwriteStore && senderOverwriteStore !== 0 && senderOverwriteStore !== "0" && stores.length > 0) {
            const overwriteStoreIndex = stores.findIndex(store => store.code === senderOverwriteStore);
            if (overwriteStoreIndex !== -1) {
                setSelectedStore(overwriteStoreIndex);
                const row = stores[overwriteStoreIndex];
                let shipper2 = {name: row["shipping_name"], company: row["shipping_company"], street_name: row["shipping_street_name"], house_number: row["shipping_street_number"], zip: row["shipping_zip"], city: row["shipping_city"], country: row["shipping_country"], email: row["shipping_email"], phone: row["shipping_phone"]};
                setShipperData(shipper2);
                if(params.receiptNr !== undefined && params.receiptNr.length > 1){
                    setShowShipperForm(false);
                }
                return; // Exit early, override takes precedence
            }
        }

        // Default behavior: use customerData.store_id if no override
        if (customerData.store_id && (typeof params.storeId == "undefined" || !params.storeId.length > 1 ) && (params.receiptNr !== undefined && params.receiptNr.length > 1) ) {
            const selectedStoreIndex = stores.findIndex(store => store.code === customerData.store_id);
            setSelectedStore(selectedStoreIndex);

            stores.forEach(row => {
                if(row.code === customerData.store_id){
                    let shipper2 = {name: row["shipping_name"], company: row["shipping_company"], street_name: row["shipping_street_name"], house_number: row["shipping_street_number"], zip: row["shipping_zip"], city: row["shipping_city"], country: row["shipping_country"], email: row["shipping_email"], phone: row["shipping_phone"]};
                    setShipperData(shipper2);
                    if(params.receiptNr !== undefined && params.receiptNr.length > 1){
                        setShowShipperForm(false);
                    }
                }
            });
        }
    }, [customerData, stores, senderOverwriteStore]);

    function changeForm(forwardOrBack){
        setCurrentStepDirection(forwardOrBack);
        if(forwardOrBack === true){ //true is forward, false is backward  
            if(SftGlobalData.debug) 
                console.log("currentForm: ", currentForm);   
            if(currentForm === "ShippingCustomer"){
                if(SftGlobalData.debug)
                    console.log("Show customer form: " + showCustomerForm);
                setVisitForm([...visitForm, currentForm]);
                setCurrentForm("ShippingSender");
            } else if(currentForm === "ShippingSender"){
                if(SftGlobalData.debug)
                    console.log("Show sender form: " + showShipperForm);
                setVisitForm([...visitForm, currentForm]);
                // In pickup mode the carrier is fixed by the configured pickup provider (kasvar
                // shipping_pickup_provider: empty | direct_bpost | myparcel_postnl | myparcel_bpost |
                // myparcel_dpd | myparcel_dhl | myparcel_ups), so the provider-selection step is
                // redundant. Resolve it to a shipment type and skip straight to the options step.
                // Prefer matching the kasvar against the loaded providers (authoritative — and covers
                // providers hidden from the normal picker via onlyShowProviders); fall back to parsing
                // the "platform_carrier" string. Falls through to the provider step if it can't resolve.
                let pickupShipmentType = null;
                if(usePickupMode && pickupProvider){
                    const match = providers?.find(p => (p.platform + "_" + p.provider) === pickupProvider);
                    if(match){
                        pickupShipmentType = {shipper: match.platform, provider: match.provider};
                    } else {
                        const parts = pickupProvider.split("_");
                        const shipper = parts.shift();
                        const provider = parts.join("_");
                        if(shipper && provider){
                            pickupShipmentType = {shipper: shipper, provider: provider};
                        }
                    }
                }
                if(pickupShipmentType){
                    if(SftGlobalData.debug)
                        console.log("[Pickup] Skipping provider step. pickup_provider kasvar:", pickupProvider,
                            "| matched loaded provider:", !!providers?.find(p => (p.platform + "_" + p.provider) === pickupProvider),
                            "| derived shipmentType:", pickupShipmentType);
                    setShipmentTypeData(pickupShipmentType);
                    setCurrentForm("shippingOptions");
                } else {
                    if(SftGlobalData.debug && usePickupMode)
                        console.log("[Pickup] Could NOT derive provider from pickup_provider kasvar:", pickupProvider, "- showing provider step.");
                    setCurrentForm("ShippingProvider");
                }
            } else if(currentForm === "ShippingProvider"){
                if(SftGlobalData.debug)
                    console.log("Show sender form: " + showProviderForm);
                setVisitForm([...visitForm, currentForm]);
                setCurrentForm("shippingOptions");
            } else if(currentForm === "shippingOptions"){
                if(SftGlobalData.debug)
                    console.log("Show sender form: " + showOptionsForm);
                setVisitForm([...visitForm, currentForm]);
                setCurrentForm("shippingPrint");
            } else {
                if(SftGlobalData.debug)
                    console.log("Euhm error?");
            }         
        } else {
            let popped = visitForm.pop();
            if (SftGlobalData.debug){
                console.log("visitForm:", visitForm)
                console.log("currentForm: ", currentForm);
                console.log("popped: ", popped);
            }
            // Navigating back after a failed shipment means the operator is going to fix something.
            // Clear the error, otherwise every kasvar-driven auto-advance gate (customer, provider,
            // options — they all require error === '') stays disabled and the wizard silently turns
            // fully manual for the rest of the session.
            if(error !== ''){
                setError('');
            }
            setCurrentForm(popped);
        }
    }
    function getForm() {
        switch(currentForm){
            case "ShippingCustomer":
                return <ShippingCustomer                 
                api={props.api} 
                error={error}
                setError={(error)=>setError(error)}
                t={props.t}
                hideSidebar={props.hideSidebar}
                hideTopbar={props.hideTopbar}
                countries={countries}
                customer={customerData}     setCustomer={(customerData)=>{setCustomerData(customerData)}}
                updateDefaultShipper={(country)=> {
                    setDefaultShippingOption((country == "BE" || country == "" ) ? defaultShippingSettings.be : defaultShippingSettings.nbe);
                    setShipmentOptionsData({...shipmentOptionsData, shipment_type: (country == "BE" || country == "" ) ? defaultShippingSettings.be : defaultShippingSettings.nbe});
                }}
                receiptNr={receiptNr}
                showLabelButton={showLabelButton}
                theme={props.theme}
                showCustomerForm={showCustomerForm}
                stepDirection={currentStepDirection}
                switchForm={(forwardOrBack)=>{changeForm(forwardOrBack);}}
                screenWidth={props.screenWidth}
                changeVisible={(visbility)=>{setShowCustomerForm(visbility);}}
                pickupEnabled={pickupEnabled}
                pickupProvider={pickupProvider}
                pickupId={pickupId}
                pickupType={pickupType}
                pickupPoint={pickupPoint}
                setPickupPoint={(point)=>setPickupPoint(point)}
                usePickup={usePickupMode}
                setUsePickup={(on)=>setUsePickupMode(on)}
                lang={props.lang} />
            case "ShippingSender":
                return <ShippingSender                 
                api={props.api} 
                error={error}
                setError={(error)=>setError(error)}
                t={props.t}
                hideSidebar={props.hideSidebar}
                hideTopbar={props.hideTopbar}
                stores={stores}
                countries={countries}
                selectedStore={selectedStore}
                showLabelButton={showLabelButton}
                receiptNr={receiptNr}
                shipper={shipperData}     setShipperData={(shipperData)=>{setShipperData(shipperData)}}
                theme={props.theme}
                stepDirection={currentStepDirection}
                switchForm={(forwardOrBack)=>{changeForm(forwardOrBack);}}
                screenWidth={props.screenWidth}
                changeVisible={(visbility)=>{setShowShipperForm(visbility);}} 
                lang={props.lang} />
            case "ShippingProvider":
                return <ShippingProvider 
                notify={(text, time, position, theme, id) => {props.notify(text, time, position, theme, id);}}
                theme={props.theme} 
                t={props.t}
                api={props.api} 
                error={error}
                setError={(error)=>setError(error)}
                hideSidebar={props.hideSidebar}
                hideTopbar={props.hideTopbar}
                receiptNr={receiptNr} 
                showLabelButton={showLabelButton}
                showProviderForm={showProviderForm}
                providers={providers} setProviders={(providers)=>setProviders(providers)} reloadProviders={reloadProviders} onlyShowProviders={onlyShowProviders}
                shipmentType={shipmentTypeData} setShipmentTypeData={(shipmentTypeData)=>{setShipmentTypeData(shipmentTypeData)}}
                switchForm={(forwardOrBack)=>{changeForm(forwardOrBack);}}
                stepDirection={currentStepDirection}
                screenWidth={props.screenWidth}
                changeVisible={(visbility)=>{setShowProviderForm(visbility);}}/>
            case "shippingOptions":
                return <ShippingOptions 
                theme={props.theme}
                t={props.t}
                lang={props.lang}
                receiptNr={receiptNr} 
                setReceiptNr={(receiptNr)=>setReceiptNr(receiptNr)}
                hideSidebar={props.hideSidebar}
                hideTopbar={props.hideTopbar}
                api={props.api} 
                error={error}
                setError={(error)=>setError(error)}
                customer={customerData}
                shipper={shipperData}
                showOptionsForm={showOptionsForm}
                printReturnLabel={printReturnLabel}
                stepDirection={currentStepDirection}
                shipmentType={shipmentTypeData}
                selectedOption={selectedOption}
                defaultShipper={defaultShippingOption}
                setSelectedOption={(selectedOption)=>setSelectedOption(selectedOption)}
                setSelectedPrintOption={(selectedPrintOption)=>setSelectedPrintOption(selectedPrintOption)}
                shipmentOptions={shipmentOptionsData} setShipmentOptions={(shipmentOptionsData)=>{setShipmentOptionsData(shipmentOptionsData)}}
                receiptParcelValue={receiptParcelValue}
                receiptParcelWeight={receiptParcelWeight}
                autofillParcel={autofillParcel}
                pickupPoint={pickupPoint}
                switchForm={(forwardOrBack)=>{changeForm(forwardOrBack);}}
                changeVisible={(visbility)=>{setShowOptionsForm(visbility);}}
                screenWidth={props.screenWidth}
                showLabelButton={showLabelButton}/>
            case "shippingPrint":
                return <ShippingPrint
                theme={props.theme}
                t={props.t}
                lang={props.lang}
                receiptNr={receiptNr}
                selectedStore={storeSet ? selectedStore : ""}
                hideSidebar={props.hideSidebar}
                hideTopbar={props.hideTopbar}
                error={error}
                setError={(error)=>setError(error)}
                api={props.api}
                sftAccountId={sftAccountId} 
                customer={customerData}
                shipper={shipperData}
                showPrintForm={showPrintForm}
                shipmentType={shipmentTypeData}
                selectedOption={selectedOption} 
                selectedPrintOption={selectedPrintOption}
                showLabelButton={showLabelButton}
                setSelectedPrintOption={(selectedPrintOption)=>setSelectedPrintOption(selectedPrintOption)}
                shipmentOptions={shipmentOptionsData} setShipmentOptions={(shipmentOptionsData)=>{setShipmentOptionsData(shipmentOptionsData)}}
                pickupPoint={pickupPoint}
                switchForm={(forwardOrBack)=>{changeForm(forwardOrBack);}}
                screenWidth={props.screenWidth}
                changeVisible={(visbility)=>{setShowOptionsForm(visbility);}}/>
            default:
                return <div>An unexpected error occurred...</div>
        }
    }

    return (
        <div className={(props.hideSidebar === true ? ('container_content margin_top_none '+ props.theme + ' container_content_' + props.theme + (props.screenWidth < 810 ? ' shipping_content_small ' : ' shipping ')) : (props.screenWidth < 600 ? ('not_expanded shipping container_content _80perc '+ props.theme + ' container_content_' + props.theme) : ('expanded shipping container_content _80perc ' + props.theme + ' container_content_' + props.theme)))} >
            {loading && <div className={"container_list__title " + props.theme} style={{display:"flex", justifyContent: "space-evenly", marginTop: 5, border: 1}}>
                        <TailSpin 
                            height="40"
                            width="40"
                            color={Colors.sft_blue}
                            ariaLabel='loading'
                        />
                    </div>}
                   
            {!loading && getForm()}
        </div>
    );
}

export default ShippingScreen;
